module.exports = __webpack_public_path__ + "media/images/emblems/Iserables-coat_of_arms-b411a3ba3e19644bfa7ad84794ebff41.svg";